module.exports = __webpack_public_path__ + "static/sport/game-5.abe5c56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/game-5.png
// module id = skq/
// module chunks = 0